module.exports = __webpack_public_path__ + "static/media/Giving2.7c7f1b90.png";